type Props = {
  onBack: () => void;
};

export default function InvoicesPageHeader({ onBack }: Props) {
  return (
    <div
      className="relative overflow-hidden"
      style={{
        background:
          "linear-gradient(145deg,#78350F 0%,#92400E 60%,#B45309 100%)",
      }}
    >
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute rounded-full"
          style={{
            width: 160,
            height: 160,
            top: -30,
            right: -10,
            background: "rgba(255,255,255,0.06)",
            filter: "blur(30px)",
          }}
        />
      </div>
      <div className="relative px-5 pb-5" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)" }}>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onBack}
            className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
            style={{
              background: "rgba(255,255,255,0.1)",
              border: "1px solid rgba(255,255,255,0.15)",
            }}
          >
            <i
              className="ri-arrow-left-line"
              style={{ fontSize: 18, color: "#fff" }}
            />
          </button>
          <div className="flex items-center gap-2">
            <div
              className="w-7 h-7 rounded-lg flex items-center justify-center"
              style={{ background: "rgba(255,255,255,0.15)" }}
            >
              <i
                className="ri-receipt-line text-white"
                style={{ fontSize: 14 }}
              />
            </div>
            <div>
              <div className="text-base font-bold text-white leading-tight">
                电子发票
              </div>
              <div
                className="text-xs leading-tight"
                style={{ color: "rgba(255,255,255,0.5)" }}
              >
                美伊旅行
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
